import React, { useEffect, useRef, useState, useCallback } from "react";
import {
  View,
  Text,
  TouchableOpacity,
  Image,
  Animated,
  Dimensions,
  ActivityIndicator,
} from "react-native";
import { LinearGradient } from "expo-linear-gradient";
import { AppColors } from "../../utility/AppColors";
import { AppFontStyle } from "../../styles/AppFontStyle";
import { AppImages } from "../../utility/AppImages";
import Avatar from "../choose-avatar-components/Avatar";
import { toast } from "react-toastify";
import { getNotificationById } from "../../services/notification";
import {
  fetchUserBalance,
  fetchPaymentBeltExchange,
} from "../../services/profileAPI";
import { handleApiError } from "../../services/errorHandler";
import { base_url, endpoints } from "../../Api/configs";
import { fetchUserConnectionStatus } from "../../services/stream";
import { useNotifications } from "../../context/NotificationContext";
import { useUserData } from "../../context/UserDataContext";
import { navigateToScreen } from "../../utility/NavigationHelper";
import { StackActions, useNavigation } from "@react-navigation/native";
import { Base64 } from "js-base64";
import { AppScreens } from "../../screens/Utility/AppScreens";
import { storePendingChallengeAccept } from "../../utility/urlUtils";
import { parseResponseBody } from "../../services/apiClient";
import BeltPurchaseSuccessModal from "../../screens/Auth/WebScreens/BeltScreens/BeltPurchaseSuccessModal";
import ChallengeAcceptModal from "../../screens/Auth/WebScreens/Notifications/NotificationPopup/ChallengeAcceptModal";
import CornfirmPurchaseBeltModal from "../../screens/Auth/WebScreens/BeltScreens/CornfirmPurchaseBeltModal";
import { storeUserActivity, ACTIVITY_TYPES } from "../../services/activityService";
import { DEVICE_SIZES, useDeviceSize } from "rn-responsive-styles";

const { height: screenHeight, width: screenWidth } = Dimensions.get("window");

interface ChallengeNotificationPopupProps {
  visible: boolean;
  onClose: () => void;
  onAccept: () => void;
  onViewDetails: () => void;
  challengeID: string;
  username: string;
  accessToken: string;
}

const ChallengeNotificationPopup: React.FC<ChallengeNotificationPopupProps> = ({
  visible,
  onClose,
  onAccept,
  onViewDetails,
  challengeID,
  username,
  accessToken,
}) => {
  const slideAnim = useRef(new Animated.Value(screenHeight)).current;
  const deviceSize = useDeviceSize();
  const isMobile = deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM;
  const [challengeDetails, setChallengeDetails] = useState<any>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [showAcceptLoader, setAcceptLoader] = useState(false);
  const [showAcceptModal, setShowAcceptModal] = useState(false);
  const [cornfirmPurchaseBeltModal, setCornfirmPurchaseBeltModal] =
    useState(false);
  const [numberOfBelts, setNumberOfBelts] = useState("0");
  const [insufficientStakesError, setInsufficientStakesError] = useState(null);
  const [userTokenBalance, setUserTokenBalance] = useState(0);
  const [userBalanceData, setUserBalanceData] = useState(null);
  const [beltPurchaseSuccessModal, setBeltPurchaseSuccessModal] =
    useState(false);
  const [platformStatus, setPlatformStatus] = useState({
    YouTube: "Not connected",
    Twitch: "Not connected",
  });
  const [arrBeltMedalType, setArrBeltMedalType] = useState([
    {
      id: 0,
      value: 0,
      image: AppImages.icCoinBelt,
      isAvailableAmountSelected: 1,
      title: "Coin",
      isSelected: false,
      currentPrize: 0,
      sellPrice: 0,
      locked: true,
      purchaseLock: true,
      stakeTokenAmount: 0,
      stakeBeltAmount: 0,
      stakeCurrencyAmount: 0,
      purchasedBeltAmount: 0,
      width: isMobile ? 69 : 77,
      height: 69,
      popupIconWidth: 58,
    },
    {
      id: 1,
      image: AppImages.icBronzeBelt,
      title: "Bronze",
      isSelected: true,
      currentPrize: 0,
      value: 0,
      sellPrice: 0,
      purchaseLock: false,
      purchaseToken: 0,
      purchasedBeltAmount: 0,
      width: 99,
      height: 79,
      popupIconWidth: 73,
    },
    {
      id: 2,
      image: AppImages.icSilverBelt,
      title: "Silver",
      isSelected: false,
      currentPrize: 0,
      value: 0,
      sellPrice: 0,
      purchaseLock: true,
      purchaseToken: 0,
      purchasedBeltAmount: 0,
      width: 99,
      height: 79,
      popupIconWidth: 73,
    },
    {
      id: 3,
      image: AppImages.icGoldBelt,
      title: "Gold",
      isSelected: false,
      currentPrize: 0,
      value: 0,
      sellPrice: 0,
      purchaseLock: true,
      purchaseToken: 0,
      purchasedBeltAmount: 0,
      width: 99,
      height: 79,
      popupIconWidth: 73,
    },
    {
      id: 4,
      image: AppImages.icPlatinumBelt,
      title: "Platinum",
      isSelected: false,
      currentPrize: 0,
      value: 0,
      sellPrice: 0,
      purchaseLock: true,
      purchaseToken: 0,
      purchasedBeltAmount: 0,
      width: 99,
      height: 79,
      popupIconWidth: 73,
    },
  ]);
  const [refreshAPICall, setRefreshAPICall] = useState(false);
  const navigation = useNavigation();
  const { userData } = useUserData();
  const { sendNotification, setUpdateNotification, showChallengeActionPopup } =
    useNotifications();

  // Fetch challenge details
  const callGetChallengeDetails = async (notificationId: string) => {
    setIsLoading(true);
    try {
      const response = await getNotificationById(accessToken, notificationId);
      if (response.statusCode === 200) {
        setChallengeDetails(response.body.notification);
      } else {
        toast.error("Failed to fetch challenge details");
      }
    } catch (error) {
      console.error("Error fetching challenge details:", error);
      toast.error("Failed to fetch challenge details");
      onClose();
    } finally {
      setIsLoading(false);
    }
  };

  // Check user's token balance
  const checkUserTokenBalance = useCallback(async () => {
    try {
      const response = await fetchUserBalance(accessToken);
      if (response && response.body) {
        const balance = response.body.koCoins || 0;
        setUserTokenBalance(balance);
      }
    } catch (error) {
      console.error("Error checking token balance:", error);
      toast.error("Error checking token balance");
    }
  }, [accessToken]);

  // Check user balance for belts
  const checkUserBalanceAPI = async () => {
    try {
      const data = await fetchUserBalance(accessToken);
      const responseBody =
        typeof data.body === "string" ? JSON.parse(data.body) : data.body;
      if (data) {
        setUserBalanceData(responseBody);
        const belts = responseBody?.belts;
        if (belts) {
          const arr = [...arrBeltMedalType];
          arr.map((item) => {
            if (item.title === "Bronze") item.value = Number(belts.bronze || 0);
            else if (item.title === "Silver")
              item.value = Number(belts.silver || 0);
            else if (item.title === "Gold")
              item.value = Number(belts.gold || 0);
            else if (item.title === "Platinum")
              item.value = Number(belts.platinum || 0);
          });
          setArrBeltMedalType(arr);
        }
      } else {
        handleApiError(data.statusCode, data.error);
      }
    } catch (error) {
      toast.error(error.message);
    }
  };

  // Fetch belt exchange rates
  const paymentBeltExchangeAPI = async () => {
    try {
      const response = await fetchPaymentBeltExchange(accessToken);
      if (response.statusCode === 200) {
        const arr = [...arrBeltMedalType];
        arr.map((item) => {
          if (item.title === "Bronze") {
            item.currentPrize = Number(response.exchangeRates.bronze);
            item.sellPrice = Number(response.sellRates.bronze);
          } else if (item.title === "Silver") {
            item.currentPrize = Number(response.exchangeRates.silver);
            item.sellPrice = Number(response.sellRates.silver);
          } else if (item.title === "Gold") {
            item.currentPrize = Number(response.exchangeRates.gold);
            item.sellPrice = Number(response.sellRates.gold);
          } else if (item.title === "Platinum") {
            item.currentPrize = Number(response.exchangeRates.platinum);
            item.sellPrice = Number(response.sellRates.platinum);
          }
        });
        setArrBeltMedalType(arr);
      } else {
        handleApiError(response.statusCode, response.error);
      }
    } catch (error) {
      toast.error(error.message);
    }
  };

  // Fetch platform status
  const fetchStatus = async () => {
    try {
      const response = await fetchUserConnectionStatus(accessToken);
      if (response.statusCode === 200) {
        setPlatformStatus(response.body);
      } else {
        toast.error("Failed to fetch platform connection status.");
      }
    } catch (error) {
      console.error("Error fetching platform status:", error);
      toast.error("Failed to fetch platform connection status.");
    }
  };

  // Handle profile update
  const handleProfileUpdate = async () => {
    try {
      const response = await fetch(`${base_url}${endpoints.auth.userProfile}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ accessToken }),
      });

      let data = await response.json();
      data = parseResponseBody(data);

      if (response.status === 200) {
        const profileData = data.body;
        const updatedPlayGames = [
          ...(profileData?.playedGames || []),
          {
            eventId: challengeDetails?.eventDetails?.eventID,
            gameTitle: challengeDetails?.eventDetails?.gameTitle,
          },
        ];
        const updatedChallenged = [
          ...(profileData?.challenged || []),
          {
            eventId: challengeDetails?.eventDetails?.eventID,
            gameTitle: challengeDetails?.eventDetails?.gameTitle,
          },
        ];

        const params = {
          username,
          accessToken,
          challenged: updatedChallenged,
        };

        const updateResponse = await fetch(
          `${base_url}${endpoints.auth.updateProfile}`,
          {
            method: "PATCH",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ body: params }),
          }
        );

        let updateData = await updateResponse.json();
        updateData = parseResponseBody(updateData);

        if (updateResponse.status === 200) {
          toast.success("User profile updated successfully");
        } else {
          toast.error(updateData.body.error);
        }
      } else {
        toast.error("Failed to fetch user profile data");
      }
    } catch (error) {
      toast.error("Failed to update user profile");
    }
  };

  // Handle accept challenge
  const handleAcceptPress = async (userResponse: boolean) => {
    setAcceptLoader(true);
    const url = `${base_url}${endpoints.events.challengeRespond}`;

    try {
      const response = await fetch(url, {
        mode: "cors",
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          accessToken,
          notificationId: challengeID,
          response: userResponse,
        }),
      });

      let data = await response.json();
      data = parseResponseBody(data);

      if (response.status === 200) {
        if (data.statusCode === 200 || data.statusCode === 201) {
          toast.success("Challenge Accepted Successfully");

          const { body } = data;
          console.log("body", body, data);
          const { notificationId, senderId } = body;

          if (userResponse) {
            onAccept();
            await fetchStatus();
            setShowAcceptModal(true);
            handleProfileUpdate();
          }

          const updateResponse = {
            challengeId: challengeID,
            response: userResponse,
          };

          setUpdateNotification(updateResponse);
          await sendNotification(senderId, notificationId);

          // Track activity (fire and forget)
          const eventId = challengeDetails?.eventDetails?.eventID;
          if (eventId) {
            storeUserActivity(
              accessToken,
              eventId,
              userResponse ? ACTIVITY_TYPES.CHALLENGE_ACCEPTED : ACTIVITY_TYPES.CHALLENGE_REJECTED
            ).catch((err) => console.warn("Failed to track activity:", err));
          }
        } else if (data.statusCode === 400) {
          let errorMessage = "";
          if (data.body && typeof data.body === "object" && data.body.error) {
            errorMessage = data.body.error;
          } else if (typeof data.body === "string") {
            try {
              const parsedBody = JSON.parse(data.body);
              errorMessage = parsedBody.error || "";
            } catch (e) {
              errorMessage = data.body;
            }
          }

          const match = errorMessage.match(/Required:\s*(\d+)\s*(\w+)/i);
          if (match) {
            const requiredAmount = parseInt(match[1]);
            const beltType = match[2];

            setInsufficientStakesError({
              requiredAmount,
              beltType,
              fullMessage: errorMessage,
            });

            const userBronzeBelts =
              arrBeltMedalType.find((b) => b.title === "Bronze")?.value || 0;
            const beltsToBuy = Math.max(0, requiredAmount - userBronzeBelts);
            setNumberOfBelts(beltsToBuy.toString());
          } else {
            setInsufficientStakesError({
              fullMessage: errorMessage,
            });
          }

          setCornfirmPurchaseBeltModal(true);
        } else {
          try {
            const parsedData = JSON.parse(data.body);
            toast.error(parsedData.message || "An error occurred");
          } catch (error) {
            toast.error(data.body);
          }
        }
      } else {
        toast.error("Failed to respond to challenge");
      }
    } catch (error) {
      toast.error("Failed to respond to challenge");
    } finally {
      setAcceptLoader(false);
    }
  };

  useEffect(() => {
    if (challengeID) {
      callGetChallengeDetails(challengeID);
      checkUserTokenBalance();
      checkUserBalanceAPI();
      paymentBeltExchangeAPI();
    }
  }, [challengeID, checkUserTokenBalance]);

  useEffect(() => {
    if (visible) {
      Animated.spring(slideAnim, {
        toValue: 0,
        useNativeDriver: true,
        tension: 65,
        friction: 10,
      }).start();
    } else {
      Animated.timing(slideAnim, {
        toValue: screenHeight,
        duration: 250,
        useNativeDriver: true,
      }).start();
    }
  }, [visible]);

  if (!visible || isLoading || !challengeDetails) {
    return null;
  }

  const eventDetails = challengeDetails?.eventDetails || {};
  const challengerName = eventDetails.organiserId || "Unknown";
  const gameTitle = eventDetails.gameTitle || "Unknown Game";
  const eventDate = eventDetails.eventStartTime
    ? new Date(eventDetails.eventStartTime).toLocaleDateString("en-US", {
      month: "2-digit",
      day: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    })
    : "";

  const beltData = (eventDetails?.stakes ?? [])
    .filter((stake: any) => stake.quantity > 0)
    .map((stake: any) => {
      let beltImage;
      let beltText;

      switch (stake.type) {
        case "Token":
          beltImage = AppImages.icCoinBelt;
          beltText = "Token";
          break;
        case "Bronze":
          beltImage = AppImages.icBronzeBelt;
          beltText = "Bronze";
          break;
        case "Silver":
          beltImage = AppImages.icSilverBelt;
          beltText = "Silver";
          break;
        case "Gold":
          beltImage = AppImages.icGoldBelt;
          beltText = "Gold";
          break;
        case "Platinum":
          beltImage = AppImages.icPlatinumBelt;
          beltText = "Platinum";
          break;
        default:
          beltImage = AppImages.icCoinBelt;
          beltText = "Token";
      }

      return {
        beltImage,
        beltText,
        amount: stake.quantity,
      };
    });

  const totalCredits = eventDetails?.totalCredits || 0;
  const creditsWorth = eventDetails?.totalBalance || "0.00";
  const stakeAmount = eventDetails?.stake || 0;
  const hasInsufficientTokens = userTokenBalance < stakeAmount;

  // Desktop popup
  if (!isMobile) {
    return (
      <View
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: 9999,
        }}
        pointerEvents="box-none"
      >
        <Animated.View
          style={{
            position: "absolute",
            bottom: 16,
            right: 16,
            width: 400,
            maxHeight: 550,
            borderRadius: 8,
            transform: [{ translateY: slideAnim }],
            shadowColor: "#000",
            shadowOffset: { width: 0, height: 4 },
            shadowOpacity: 0.3,
            shadowRadius: 8,
            elevation: 10,
          }}
        >
          <LinearGradient
            colors={["#400000", "#291B1B"]}
            start={{ x: 0, y: 0 }}
            end={{ x: 1, y: 1 }}
            style={{
              borderRadius: 8,
              borderWidth: 2,
              borderColor: AppColors.koBrandRed,
              overflow: "hidden",
            }}
          >
            <View
              style={{
                paddingTop: 12,
                paddingHorizontal: 16,
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <View
                style={{ flexDirection: "row", alignItems: "center", gap: 8 }}
              >
                <Image
                  source={AppImages.icChallengeIcon}
                  style={{ width: 32, height: 32 }}
                  resizeMode="contain"
                />
                <View>
                  <Text
                    style={[AppFontStyle.BOLD_ANYBODY_16, { color: "white" }]}
                  >
                    Challenge Received!
                  </Text>
                  <Text
                    style={[
                      AppFontStyle.REGULAR_ANYBODY_12,
                      { color: "#CCCCCC", marginTop: 2 },
                    ]}
                  >
                    {challengerName} has challenged you
                  </Text>
                </View>
              </View>
              <TouchableOpacity onPress={onClose}>
                <Image
                  source={AppImages.icClose}
                  style={{ width: 20, height: 20, tintColor: "white" }}
                  resizeMode="contain"
                />
              </TouchableOpacity>
            </View>

            <View style={{ padding: 12 }}>
              {hasInsufficientTokens && (
                <View
                  style={{
                    backgroundColor: "rgba(0, 0, 0, 0.3)",
                    borderRadius: 8,
                    padding: 12,
                    marginBottom: 10,
                  }}
                >
                  <Text
                    style={[
                      AppFontStyle.BOLD_ANYBODY_14,
                      {
                        color: "white",
                        textAlign: "center",
                        marginBottom: 8,
                      },
                    ]}
                  >
                    Note: This challenge requires {stakeAmount} KO tokens
                  </Text>
                  <Text
                    style={[
                      AppFontStyle.REGULAR_ANYBODY_12,
                      { color: "#CCCCCC", textAlign: "center" },
                    ]}
                  >
                    You have {userTokenBalance} KO tokens. Add{" "}
                    {stakeAmount - userTokenBalance} KO tokens to participate.
                  </Text>
                </View>
              )}

              <View
                style={{
                  backgroundColor: "rgba(0, 0, 0, 0.3)",
                  borderRadius: 8,
                  padding: 12,
                  marginBottom: 10,
                }}
              >
                <View
                  style={{
                    flexDirection: "row",
                    alignItems: "flex-start",
                  }}
                >
                  <View
                    style={{
                      width: 50,
                      height: 50,
                      borderRadius: 25,
                      borderWidth: 2,
                      borderColor: AppColors.koBrandRed,
                      marginRight: 10,
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      overflow: "hidden",
                    }}
                  >
                    <Avatar
                      src={eventDetails.organiserProfilePicture || ""}
                      variant="profile"
                    />
                  </View>
                  <View style={{ flex: 1 }}>
                    <Text
                      style={[AppFontStyle.BOLD_ANYBODY_16, { color: "white" }]}
                      numberOfLines={1}
                    >
                      {challengerName}
                    </Text>
                    <Text
                      style={[
                        AppFontStyle.REGULAR_ANYBODY_12,
                        { color: "#CCCCCC" },
                      ]}
                      numberOfLines={1}
                    >
                      • {gameTitle} • {eventDate}
                    </Text>
                  </View>
                </View>
              </View>

              <View
                style={{
                  backgroundColor: "rgba(0, 0, 0, 0.3)",
                  borderRadius: 8,
                  padding: 12,
                  marginBottom: 10,
                }}
              >
                <Text
                  style={[
                    AppFontStyle.BOLD_ANYBODY_14,
                    { color: "white", marginBottom: 8 },
                  ]}
                >
                  Wager
                </Text>
                <View
                  style={{
                    flexDirection: "row",
                    justifyContent: "flex-start",
                    alignItems: "center",
                  }}
                >
                  {beltData.map((belt: any, index: number) => (
                    <View
                      key={index}
                      style={{
                        alignItems: "center",
                        gap: 4,
                      }}
                    >
                      <Image
                        source={belt.beltImage}
                        style={{ width: 50, height: 50 }}
                        resizeMode="contain"
                      />
                      <View
                        style={{
                          backgroundColor: "transparent",
                          borderRadius: 4,
                          paddingVertical: 2,
                          paddingHorizontal: 4,
                        }}
                      >
                        <Text
                          style={[
                            AppFontStyle.BOLD_ANYBODY_14,
                            { color: "white", textAlign: "center" },
                          ]}
                        >
                          {belt.amount}
                        </Text>
                        <Text
                          style={[
                            AppFontStyle.REGULAR_ANYBODY_10,
                            { color: "#CCCCCC", textAlign: "center" },
                          ]}
                        >
                          {belt.beltText}
                        </Text>
                      </View>
                    </View>
                  ))}
                </View>
              </View>

              <View
                style={{
                  flexDirection: "row",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: 12,
                }}
              >
                <View style={{ flex: 1 }}>
                  <Text
                    style={[
                      AppFontStyle.REGULAR_ANYBODY_12,
                      { color: "white" },
                    ]}
                  >
                    Accept challenge to earn:
                  </Text>
                  <Text
                    style={[
                      AppFontStyle.BOLD_ANYBODY_14,
                      { color: "white", marginTop: 2 },
                    ]}
                  >
                    {totalCredits} Credits worth
                  </Text>
                </View>
                <View
                  style={{
                    borderWidth: 2,
                    borderColor: AppColors.koBrandRed,
                    borderRadius: 6,
                    paddingVertical: 8,
                    paddingHorizontal: 16,
                    minWidth: 80,
                    alignItems: "center",
                  }}
                >
                  <Text
                    style={[AppFontStyle.BOLD_ANYBODY_20, { color: "white" }]}
                  >
                    ${creditsWorth}
                  </Text>
                </View>
              </View>

              <View style={{ flexDirection: "row", gap: 10 }}>
                <TouchableOpacity onPress={onViewDetails} style={{ flex: 1 }}>
                  <View
                    style={{
                      backgroundColor: "transparent",
                      borderWidth: 1,
                      borderColor: "white",
                      borderRadius: 8,
                      paddingVertical: 12,
                      alignItems: "center",
                    }}
                  >
                    <Text
                      style={[AppFontStyle.BOLD_ANYBODY_16, { color: "white" }]}
                    >
                      View Details
                    </Text>
                  </View>
                </TouchableOpacity>
                <TouchableOpacity
                  onPress={() => {
                    if (hasInsufficientTokens) {
                      toast.info(
                        `You need ${stakeAmount - userTokenBalance
                        } more KO tokens to accept this challenge`
                      );
                      navigateToScreen(navigation, AppScreens.PurchaseScreen);
                      onClose();
                    } else {
                      handleAcceptPress(true);
                    }
                  }}
                  style={{ flex: 1 }}
                  disabled={
                    eventDetails.organiserId === username ||
                    eventDetails.status === "accepted" ||
                    eventDetails.status === "rejected" ||
                    showAcceptLoader
                  }
                >
                  <View
                    style={{
                      backgroundColor:
                        eventDetails.organiserId === username ||
                          eventDetails.status === "accepted" ||
                          eventDetails.status === "rejected" ||
                          showAcceptLoader
                          ? AppColors.grayColor_393939
                          : hasInsufficientTokens
                            ? AppColors.appViolentColor_6D08C3
                            : "#51AF07",
                      borderRadius: 8,
                      paddingVertical: 12,
                      alignItems: "center",
                      opacity:
                        eventDetails.organiserId === username ||
                          eventDetails.status === "accepted" ||
                          eventDetails.status === "rejected" ||
                          showAcceptLoader
                          ? 0.5
                          : 1,
                    }}
                  >
                    <Text
                      style={[AppFontStyle.BOLD_ANYBODY_16, { color: "white" }]}
                    >
                      {hasInsufficientTokens
                        ? "Buy KO tokens"
                        : "Accept Challenge"}
                    </Text>
                  </View>
                </TouchableOpacity>
              </View>
            </View>
          </LinearGradient>
          {showAcceptModal && (
            <ChallengeAcceptModal
              eventID={challengeDetails?.eventId}
              showModal={showAcceptModal}
              eventDetails={challengeDetails?.eventDetails}
              setShowModal={setShowAcceptModal}
              setPopup={onClose}
              platformStatus={platformStatus}
            />
          )}
          {cornfirmPurchaseBeltModal && (
            <CornfirmPurchaseBeltModal
              accessToken={accessToken}
              numberOfBelts={numberOfBelts}
              setArrBeltMedalType={setArrBeltMedalType}
              arrBeltMedalType={arrBeltMedalType}
              showModal={cornfirmPurchaseBeltModal}
              setRefreshAPICall={setRefreshAPICall}
              userBalanceData={userBalanceData}
              setShowModal={setCornfirmPurchaseBeltModal}
              eventID={challengeDetails?.eventDetails?.eventID || challengeDetails?.eventId}
              dataSelectedBelt={arrBeltMedalType.find(
                (item) => item.isSelected
              )}
              insufficientStakesError={insufficientStakesError}
              selectedBelt={() => {
                setBeltPurchaseSuccessModal(true);
                setInsufficientStakesError(null);
              }}
              jumpToPurchaseToken={(isNavigate: boolean) => {
                if (isNavigate) {
                  const eventId = challengeDetails?.eventDetails?.eventID || challengeDetails?.eventId;
                  // Store pending challenge context for auto-resume after payment
                  storePendingChallengeAccept(challengeID, eventId);
                  navigateToScreen(navigation, AppScreens.PurchaseScreen, {
                    eventID: eventId,
                    type: "notification",
                  });
                  onClose();
                }
              }}
            />
          )}
          {beltPurchaseSuccessModal && (
            <BeltPurchaseSuccessModal
              setSaleBeltModal={() => { }} // Placeholder, implement if needed
              arrBeltMedalType={arrBeltMedalType}
              showModal={beltPurchaseSuccessModal}
              setShowModal={setBeltPurchaseSuccessModal}
              numberOfBelts={numberOfBelts}
              dataBuyBelt={arrBeltMedalType.find((item) => item.isSelected)}
            />
          )}
          {showAcceptLoader && (
            <View
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: "rgba(0, 0, 0, 0.5)",
              }}
            >
              <ActivityIndicator size="large" />
            </View>
          )}
        </Animated.View>
      </View>
    );
  }

  // Mobile bottom sheet
  return (
    <View
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 9999,
      }}
      pointerEvents="box-none"
    >
      <Animated.View
        style={{
          position: "absolute",
          bottom: 0,
          left: 0,
          right: 0,
          maxHeight: screenHeight * 0.7,
          borderTopLeftRadius: 16,
          borderTopRightRadius: 16,
          transform: [{ translateY: slideAnim }],
          overflow: "hidden",
        }}
      >
        <LinearGradient
          colors={["#400000", "#291B1B"]}
          start={{ x: 0, y: 0 }}
          end={{ x: 1, y: 1 }}
          style={{
            borderTopLeftRadius: 16,
            borderTopRightRadius: 16,
            borderWidth: 2,
            borderColor: AppColors.koBrandRed,
          }}
        >
          <View
            style={{
              width: 40,
              height: 4,
              backgroundColor: AppColors.koBrandLightGray,
              alignSelf: "center",
              marginTop: 8,
              marginBottom: 12,
              borderRadius: 2,
            }}
          />

          <View
            style={{
              paddingTop: 12,
              paddingHorizontal: 12,
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <View
              style={{ flexDirection: "row", alignItems: "center", gap: 8 }}
            >
              <Image
                source={AppImages.icChallengeIcon}
                style={{ width: 24, height: 24 }}
                resizeMode="contain"
              />
              <View>
                <Text
                  style={[AppFontStyle.BOLD_ANYBODY_14, { color: "white" }]}
                >
                  Challenge Received!
                </Text>
                <Text
                  style={[
                    AppFontStyle.REGULAR_ANYBODY_10,
                    { color: "#CCCCCC", marginTop: 2 },
                  ]}
                >
                  {challengerName} has challenged you
                </Text>
              </View>
            </View>
            <TouchableOpacity onPress={onClose}>
              <Image
                source={AppImages.icClose}
                style={{ width: 16, height: 16, tintColor: "white" }}
                resizeMode="contain"
              />
            </TouchableOpacity>
          </View>

          <View style={{ padding: 12 }}>
            {hasInsufficientTokens && (
              <View
                style={{
                  backgroundColor: "rgba(0, 0, 0, 0.3)",
                  borderRadius: 8,
                  padding: 12,
                  marginBottom: 8,
                }}
              >
                <Text
                  style={[
                    AppFontStyle.BOLD_ANYBODY_12,
                    { color: "white", textAlign: "center", marginBottom: 6 },
                  ]}
                >
                  Note: This challenge requires {stakeAmount} KO tokens
                </Text>
                <Text
                  style={[
                    AppFontStyle.REGULAR_ANYBODY_10,
                    { color: "#CCCCCC", textAlign: "center" },
                  ]}
                >
                  You have {userTokenBalance} KO tokens. Add{" "}
                  {stakeAmount - userTokenBalance} KO tokens to participate.
                </Text>
              </View>
            )}

            <View
              style={{
                backgroundColor: "rgba(0, 0, 0, 0.3)",
                borderRadius: 8,
                padding: 12,
                marginBottom: 8,
              }}
            >
              <View
                style={{
                  flexDirection: "row",
                  alignItems: "flex-start",
                }}
              >
                <View
                  style={{
                    width: 50,
                    height: 50,
                    borderRadius: 25,
                    borderWidth: 2,
                    borderColor: AppColors.koBrandRed,
                    marginRight: 10,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    overflow: "hidden",
                  }}
                >
                  <Avatar
                    src={eventDetails.organiserProfilePicture || ""}
                    variant="profile"
                  />
                </View>
                <View style={{ flex: 1 }}>
                  <Text
                    style={[AppFontStyle.BOLD_ANYBODY_14, { color: "white" }]}
                    numberOfLines={1}
                  >
                    {challengerName}
                  </Text>
                  <Text
                    style={[
                      AppFontStyle.REGULAR_ANYBODY_10,
                      { color: "#CCCCCC" },
                    ]}
                    numberOfLines={1}
                  >
                    • {gameTitle} • {eventDate}
                  </Text>
                </View>
              </View>
            </View>

            <View
              style={{
                backgroundColor: "rgba(0, 0, 0, 0.3)",
                borderRadius: 8,
                padding: 12,
                marginBottom: 8,
              }}
            >
              <Text
                style={[
                  AppFontStyle.BOLD_ANYBODY_12,
                  { color: "white", marginBottom: 6 },
                ]}
              >
                Wager
              </Text>
              <View
                style={{
                  flexDirection: "row",
                  justifyContent: "flex-start",
                  alignItems: "center",
                  gap: 8,
                }}
              >
                {beltData.map((belt: any, index: number) => (
                  <View
                    key={index}
                    style={{
                      alignItems: "center",
                      gap: 2,
                    }}
                  >
                    <Image
                      source={belt.beltImage}
                      style={{ width: 40, height: 40 }}
                      resizeMode="contain"
                    />
                    <View
                      style={{
                        backgroundColor: "transparent",
                        borderRadius: 4,
                        paddingVertical: 2,
                        paddingHorizontal: 4,
                      }}
                    >
                      <Text
                        style={[
                          AppFontStyle.BOLD_ANYBODY_12,
                          { color: "white", textAlign: "center" },
                        ]}
                      >
                        {belt.amount}
                      </Text>
                      <Text
                        style={[
                          AppFontStyle.REGULAR_ANYBODY_10,
                          { color: "#CCCCCC", textAlign: "center" },
                        ]}
                      >
                        {belt.beltText}
                      </Text>
                    </View>
                  </View>
                ))}
              </View>
            </View>

            <View
              style={{
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: 12,
              }}
            >
              <View style={{ flex: 1 }}>
                <Text
                  style={[AppFontStyle.REGULAR_ANYBODY_10, { color: "white" }]}
                >
                  Accept challenge to earn:
                </Text>
                <Text
                  style={[
                    AppFontStyle.BOLD_ANYBODY_12,
                    { color: "white", marginTop: 2 },
                  ]}
                >
                  {totalCredits} Credits worth
                </Text>
              </View>
              <View
                style={{
                  borderWidth: 2,
                  borderColor: AppColors.koBrandRed,
                  borderRadius: 6,
                  paddingVertical: 6,
                  paddingHorizontal: 12,
                  minWidth: 70,
                  alignItems: "center",
                }}
              >
                <Text
                  style={[AppFontStyle.BOLD_ANYBODY_16, { color: "white" }]}
                >
                  ${creditsWorth}
                </Text>
              </View>
            </View>

            <View style={{ flexDirection: "row", gap: 8 }}>
              <TouchableOpacity onPress={onViewDetails} style={{ flex: 1 }}>
                <View
                  style={{
                    backgroundColor: "transparent",
                    borderWidth: 1,
                    borderColor: "white",
                    borderRadius: 8,
                    paddingVertical: 10,
                    alignItems: "center",
                  }}
                >
                  <Text
                    style={[AppFontStyle.BOLD_ANYBODY_14, { color: "white" }]}
                  >
                    View Details
                  </Text>
                </View>
              </TouchableOpacity>
              <TouchableOpacity
                onPress={() => {
                  if (hasInsufficientTokens) {
                    toast.info(
                      `You need ${stakeAmount - userTokenBalance
                      } more KO tokens to accept this challenge`
                    );
                    navigateToScreen(navigation, AppScreens.PurchaseScreen);
                    onClose();
                  } else {
                    handleAcceptPress(true);
                  }
                }}
                style={{ flex: 1 }}
                disabled={
                  eventDetails.organiserId === username ||
                  eventDetails.status === "accepted" ||
                  eventDetails.status === "rejected" ||
                  showAcceptLoader
                }
              >
                <View
                  style={{
                    backgroundColor:
                      eventDetails.organiserId === username ||
                        eventDetails.status === "accepted" ||
                        eventDetails.status === "rejected" ||
                        showAcceptLoader
                        ? AppColors.grayColor_393939
                        : hasInsufficientTokens
                          ? AppColors.appViolentColor_6D08C3
                          : "#51AF07",
                    borderRadius: 8,
                    paddingVertical: 10,
                    alignItems: "center",
                    opacity:
                      eventDetails.organiserId === username ||
                        eventDetails.status === "accepted" ||
                        eventDetails.status === "rejected" ||
                        showAcceptLoader
                        ? 0.5
                        : 1,
                  }}
                >
                  <Text
                    style={[AppFontStyle.BOLD_ANYBODY_14, { color: "white" }]}
                  >
                    {hasInsufficientTokens
                      ? "Buy KO tokens"
                      : "Accept Challenge"}
                  </Text>
                </View>
              </TouchableOpacity>
            </View>
          </View>
        </LinearGradient>
        {showAcceptModal && (
          <ChallengeAcceptModal
            eventID={challengeDetails?.eventId}
            showModal={showAcceptModal}
            eventDetails={challengeDetails?.eventDetails}
            setShowModal={setShowAcceptModal}
            setPopup={onClose}
            platformStatus={platformStatus}
          />
        )}
        {cornfirmPurchaseBeltModal && (
          <CornfirmPurchaseBeltModal
            accessToken={accessToken}
            numberOfBelts={numberOfBelts}
            setArrBeltMedalType={setArrBeltMedalType}
            arrBeltMedalType={arrBeltMedalType}
            showModal={cornfirmPurchaseBeltModal}
            setRefreshAPICall={setRefreshAPICall}
            userBalanceData={userBalanceData}
            setShowModal={setCornfirmPurchaseBeltModal}
            eventID={challengeDetails?.eventDetails?.eventID || challengeDetails?.eventId}
            dataSelectedBelt={arrBeltMedalType.find((item) => item.isSelected)}
            insufficientStakesError={insufficientStakesError}
            selectedBelt={() => {
              setBeltPurchaseSuccessModal(true);
              setInsufficientStakesError(null);
            }}
            jumpToPurchaseToken={(isNavigate: boolean) => {
              if (isNavigate) {
                const eventId = challengeDetails?.eventDetails?.eventID || challengeDetails?.eventId;
                // Store pending challenge context for auto-resume after payment
                storePendingChallengeAccept(challengeID, eventId);
                navigateToScreen(navigation, AppScreens.PurchaseScreen, {
                  eventID: eventId,
                  type: "notification",
                });
                onClose();
              }
            }}
          />
        )}
        {beltPurchaseSuccessModal && (
          <BeltPurchaseSuccessModal
            setSaleBeltModal={() => { }} // Placeholder, implement if needed
            arrBeltMedalType={arrBeltMedalType}
            showModal={beltPurchaseSuccessModal}
            setShowModal={setBeltPurchaseSuccessModal}
            numberOfBelts={numberOfBelts}
            dataBuyBelt={arrBeltMedalType.find((item) => item.isSelected)}
          />
        )}
        {showAcceptLoader && (
          <View
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              justifyContent: "center",
              alignItems: "center",
              backgroundColor: "rgba(0, 0, 0, 0.5)",
            }}
          >
            <ActivityIndicator size="large" />
          </View>
        )}
      </Animated.View>
    </View>
  );
};

export default ChallengeNotificationPopup;
